import React, { useState } from 'react';
import axios from 'axios';

const API = 'https://api.fluidstream.co';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { username, password });
      onLogin(res.data);
    } catch (err) {
      setError('Invalid username or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <img src="/logo-dark.png" alt="Fluidstream" style={styles.logoImg} />
          <p style={styles.logoSub}>IoT Platform</p>
        </div>
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>Username</label>
            <input
              style={styles.input}
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="Enter your username"
              required
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>
          {error && <div style={styles.error}>{error}</div>}
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <p style={styles.footer}>Access is provided by Fluidstream</p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #E8F4FD 0%, #C8E6F8 50%, #A8D8F0 100%)',
  },
  card: {
    background: '#fff',
    borderRadius: 16,
    padding: '44px 40px',
    width: '100%',
    maxWidth: 400,
    boxShadow: '0 20px 60px rgba(26, 115, 180, 0.15)',
    border: '1px solid rgba(26, 115, 180, 0.1)',
  },
  logo: { textAlign: 'center', marginBottom: 32 },
  logoImg: { width: 220, marginBottom: 6 },
  logoSub: { fontSize: 12, color: '#999', marginTop: 4, letterSpacing: 2, textTransform: 'uppercase' },
  form: { display: 'flex', flexDirection: 'column', gap: 16 },
  field: { display: 'flex', flexDirection: 'column', gap: 6 },
  label: { fontSize: 13, fontWeight: 600, color: '#1a2a4a' },
  input: { padding: '11px 14px', borderRadius: 8, border: '1.5px solid #d0e4f0', fontSize: 15, outline: 'none', color: '#1a2a4a', background: '#fafcfe' },
  error: { background: '#fff0f0', border: '1px solid #ffcccc', borderRadius: 8, padding: '10px 14px', color: '#cc0000', fontSize: 14 },
  button: { padding: '12px', borderRadius: 8, border: 'none', background: 'linear-gradient(135deg, #1a73b8, #2196d3)', color: '#fff', fontSize: 15, fontWeight: 600, cursor: 'pointer', marginTop: 8, boxShadow: '0 4px 12px rgba(26, 115, 180, 0.3)' },
  footer: { textAlign: 'center', fontSize: 12, color: '#aaa', marginTop: 24 },
};
